var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project"},[(_vm.iframe)?_c('iframe-project',{attrs:{"src":_vm.srcIframe,"backLinkSrc":_vm.backLinkSrc}}):_vm._e(),_vm._v(" "),(_vm.screen)?_c('screen-project',{attrs:{"project":_vm.project,"students":_vm.studentListOutput,"categoryIdent":_vm.categoryIdent,"iframe":_vm.iframe,"src":_vm.srcScreen,"backLinkSrc":_vm.backLinkSrc}}):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09bbb86d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Project.vue
// module id = null
// module chunks = 